import { render, staticRenderFns } from "./construction.vue?vue&type=template&id=bfc9881a&scoped=true"
import script from "./construction.vue?vue&type=script&lang=js"
export * from "./construction.vue?vue&type=script&lang=js"
import style0 from "./construction.vue?vue&type=style&index=0&id=bfc9881a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc9881a",
  null
  
)

export default component.exports